var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button-icon",style:(`background-color: ${_vm.backgroundColor}`)},[_vm._t("default"),_c('Icon',{staticClass:"styled-icon",attrs:{"icon":_vm.icon,"fillColor":_vm.fillColor,"strokeColor":_vm.strokeColor}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }